import Service from './Service';
import {SERVER_URL} from "../utils/Constants";
import GeneralUtils from "../utils/GeneralUtils";

export default class HsmResolutionCodeService extends Service{
    constructor() {
        super();
        this.baseURL = 'hsmResolutionCode';
    }

    findByRequestType(requestType) {
        return fetch(SERVER_URL + this.baseURL + '/findByRequestType/' + requestType, {
            headers: {'Content-Type': 'application/json', Authorization: localStorage.getItem("Authorization")}
        }).then(response => response.json()).catch(error => {
            GeneralUtils.notification(error);
        });
    }

    findByCode(code) {
        return fetch(SERVER_URL + this.baseURL + '/findByCode/' + code, {
            headers: {'Content-Type': 'application/json', Authorization: localStorage.getItem("Authorization")}
        }).then(response => response.json()).catch(error => {
            GeneralUtils.notification(error);
        });
    }
}